export const testSource = 'B2B';

export const partnerIds = {
  consoleflare: '640ec8835ecc94001441e744',
};
